<!--
  name : 김혜진
  desc :
  date : 2020-11-25
-->
<template>
  <v-container>
    <v-row no-gutters>
      <v-col cols="12">
        <div class="round8_pd20_box row_mb-40">
          <ul class="pattern_ul_terms">
            <!--
            <li>- 개인 계약은 발행 1건당 4,000P (4,400원 VAT포함)가 즉시 결제됩니다.</li>-->
            <li>- 개인 계약은 발행 1건당 3,000원이 즉시 결제됩니다.</li>
            <li>
              - 사내계약 승인시에는 별도의 요금이 부과되지 않습니다.<br /><span
                class="txtst_info_red6 pl-2"
                >※ 블록체인 생성에 따른 비용 및 SMS 비용은 별도로 부과되지
                않습니다.</span
              >
            </li>
          </ul>
        </div>
      </v-col>
      <v-col cols="12">
        <div class="dot_tt">글로싸인엔터프라이즈 결제내역</div>
        <v-row no-gutters>
          <v-col cols="12">
            <div class="feepay_round_box row_mt-20">
              <ul class="pattern_ulTxtBox">
                <li>
                  <!--conFrom:개인, conFrom st_cpn:기업-->
                  <v-chip class="conFrom">개인</v-chip>
                  <span class="txt_txt01 no_pr">{{ getName() }}</span>
                  <span class="txt_txt02">( {{ getEmail() }})</span>
                </li>
              </ul>
              <v-btn text class="btn17_C01 posiA_right0" @click="cardlink()"
                >신용카드전표조회</v-btn
              >
            </div>
          </v-col>
        </v-row>

        <!--기간검색바-->
        <v-row no-gutters class="row_mt-20 row_mb-20">
          <v-col cols="10">
            <v-menu ref="menu" v-model="menu" :close-on-content-click="false">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  class="inputH48_02 calendar_at calendar_W for_feepay dpnone"
                  v-model="dateRangeText"
                  label="기간"
                  prepend-icon="mdi-calendar"
                  readonly
                  outlined
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="dates" range locale="ko-ko">
                <v-spacer></v-spacer>
                <v-btn
                  class="btn18_00"
                  outlined
                  @click="$refs.menu.save(dates)"
                >
                  확인
                </v-btn>
                <v-btn class="btn18_00" outlined @click="menu = false">
                  취소
                </v-btn>
              </v-date-picker>
            </v-menu>
            <v-checkbox
              class="coNlist_chk size_s"
              label="기간 전체"
              value="1"
              hide-details
              v-model="searchData.ChkDateYn"
              @change="handlCheckedDate"
            ></v-checkbox>
          </v-col>
          <v-col cols="2" class="ta_right">
            <v-btn class="btn17_C01" @click="search()"
              ><span class="icon search"></span
            ></v-btn>
          </v-col>
        </v-row>
        <!--/기간검색바-->
        <!--리스트-->
        <v-row no-gutters class="feepay_list">
          <v-col cols="12">
            <!--반복: 리스트 카드 : 최대 10개-->
            <v-card
              class="feepay_carD"
              v-for="(point, index) of personalpointList"
              :key="index"
            >
              <v-list-item class="carD_box_clB">
                <div class="carD_01">
                  <div class="feepay_chip">
                    <span class="st02" v-if="point.payTypeName === '신용카드'"
                      >신용카드</span
                    >
                    <span
                      class="st01"
                      v-else-if="point.payTypeName === '휴대폰'"
                      >휴대폰</span
                    >
                    <span
                      class="st03"
                      v-else-if="point.payTypeName === '계좌이체'"
                      >계좌이체</span
                    >
                    <!--상태
                      ***상태별 텍스트 변경*** st01:휴대폰 / st02:신용카드 / st03:계좌이체 **/-->
                  </div>
                  <div class="carD_01_txt">
                    <!--사용--><span class="st_tt_01">{{
                      point.useTypeName
                    }}</span>
                    <!--결제금액--><span class="st_pay"
                      >{{
                        point.useAmt === null
                          ? ""
                          : point.useAmt | moneyCurrency
                      }}
                      원</span
                    >
                  </div>
                  <div class="dateBox">
                    <span class="st_txt">{{ getDate(point.useTime) }}</span>
                  </div>
                </div>
                <v-btn
                  text
                  class="btn17_C01"
                  v-if="point.payTypeName === '신용카드'"
                  @click="cardReceiepts(point.useCtrSeq, point.pgSeq)"
                  ><span class="icon card"></span
                  ><span class="card_txt">카드전표조회</span></v-btn
                >
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>
        <!--/리스트-->

        <!--페이지-->
        <v-row justify="center">
          <v-col cols="8">
            <v-container class="max-width">
              <v-pagination
                v-model="page"
                :length="total"
                @input="handlePageChange"
                total-visible="7"
                circle
              ></v-pagination>
            </v-container>
          </v-col>
        </v-row>
        <!--/페이지-->
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { getUsePersonList } from "@/api/payment/fee";

export default {
  name: "user",
  components: {},
  filters: {
    moneyCurrency: value => {
      if (!value) return "";
      return (
        value.toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,") + "원"
      );
    }
  },
  data() {
    return {
      // date picker
      dates: [],
      isType: "UR0020",
      pageParam: {
        page: 0,
        size: 10
      },
      searchData: {
        ChkDateYn: false,
        fromDateValue: "",
        toDateValue: ""
      },
      menu: false,
      page: 1,
      isView: "",
      total: 0,
      totalCnt: 0,
      personalpointList: null,
      chainAddr: "",
      targetUrl: process.env.VUE_APP_URL_CASH_RECEIPT,
      pgReceiptLink: process.env.VUE_APP_PG_RECEIPT_LINK
    };
  },
  computed: {
    dateRangeText() {
      if (this.dates.length === 2) {
        var start = this.dates[0];
        var end = this.dates[1];
        if (start > end) {
          this.dayChange(start, end);
          return this.dates.join(" ~ ");
        } else {
          return this.dates.join(" ~ ");
        }
      } else {
        return this.dates.join(" ~ ");
      }
    }
  },
  created() {},
  mounted() {
    this.setSearchInfo();
    this.search();
  },
  methods: {
    getName() {
      return this.$store.state.user.username;
    },
    getEmail() {
      return this.$store.state.user.useremail;
    },
    cardlink: function() {
      window.open(
        "https://pgweb.dacom.net/pg/wmp/etc/jsp/SettlementSearch.jsp",
        "_blank"
      );
    },
    dayChange(start, end) {
      this.dates = [end, start];
    },
    handlCheckedDate() {
      if (this.searchData.ChkDateYn === "1") {
        this.isChecked = true;
      } else {
        this.isChecked = false;
      }
    },
    setSearchInfo() {
      this.isChecked = false;
      this.defaultSetting();
      this.pageParam.page = 0;
      this.personalpointList = [];
      this.searchData.ChkDateYn = false;
      this.chainAddr = this.$store.state.user.useraddr;
    },
    defaultSetting() {
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      month = month >= 10 ? month : "0" + month;
      var day = date.getDate();
      day = day >= 10 ? day : "0" + day;
      var lastMonth = month - 1;
      var lastyear = date.getFullYear();
      if (month === "01") {
        lastMonth = "12";
        lastyear = year - 1;
      }
      var start = lastyear + "-" + lastMonth + "-" + day;
      var end = year + "-" + month + "-" + day;

      this.dates = [start, end];
      return this.dates.join(" ~ ");
    },
    search() {
      this.getUsePersonList();
    },
    handlePageChange(value) {
      this.pageParam.page = value - 1;
      this.getUsePersonList();
    },
    getUsePersonList() {
      getUsePersonList({
        chainAddr: this.chainAddr,
        isType: this.isType,
        pageParams: this.pageParam,
        fromDate: this.dates[0],
        toDate: this.dates[1],
        ChkDateYn: this.isChecked
      }).then(response => {
        this.personalpointList = response.rdata.list;
        this.totalCnt = response.rdata.totalCnt;
        var a = 0;
        if (parseInt(response.rdata.totalCnt % 10) > 0) {
          a = 1;
        }
        this.total = parseInt(response.rdata.totalCnt / 10) + a;
      });
    },
    getDate(date) {
      var date1 = new Date(date);
      var year = date1.getFullYear();
      var month = date1.getMonth() + 1;
      month = month >= 10 ? month : "0" + month;
      var day = date1.getDate();
      day = day >= 10 ? day : "0" + day;
      var hour = date1.getHours();
      var minutes = date1.getMinutes();
      var second = date1.getSeconds();
      var end =
        year +
        "-" +
        month +
        "-" +
        day +
        " " +
        hour +
        ":" +
        minutes +
        ":" +
        second;
      return end;
    }
  }
};
</script>
<style scoped></style>
